import { Props as SelectProps } from "react-select";
import { Option } from "@/@types/generics/Option";
import { SelectComponent } from "../SelectComponent";

type Props = SelectProps & {
	label?: string;
};

export const indicatorsEmultiOptions: Option<number>[] = [
	{ value: 1, label: "M1 - Média de Atendimentos por Pessoa por eMulti" },
	{ value: 2, label: "M2 - Ações interprofissionais realizadas por eMulti na APS" },
];

export function IndicatorsEmultiSelect({ label, ...rest }: Props) {
	return (
		<div className="d-flex flex-column">
			<label htmlFor={rest.id} className="form-label">
				{label ?? "Indicadores:"}
			</label>

			<SelectComponent
				id={rest.id}
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhum nenhum indicador encontrado"}
				options={indicatorsEmultiOptions}
				{...rest}
			/>
		</div>
	);
}
